import Vue from "vue";
import i18n from "./i18n";

import "./plugins/bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "hotel-datepicker/dist/css/hotel-datepicker.css";

import App from "./App.vue";
import store from "./store";
import router from "./routes";
import PortalVue from "portal-vue";
import VueToastr from "vue-toastr";
import { ToggleButton } from "vue-js-toggle-button";
import * as rules from "vee-validate/dist/rules";
import { messages } from "vee-validate/dist/locale/en.json";
import PrimaryButton from "./components/PrimaryButton.vue";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";

Object.keys(rules).forEach((rule) => {
  extend(rule, {
    ...rules[rule],
    message: messages[rule],
  });
});

extend("accepted", {
  validate: (value) => value === true,
  message: "This field must be accepted.",
});

Vue.use(PortalVue);
Vue.use(VueToastr);
Vue.component("vue-toastr", VueToastr);
Vue.component("ToggleButton", ToggleButton);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("PrimaryButton", PrimaryButton);
Vue.component(
  "ValidatedInput",
  () => import("./components/ValidatedInput.vue")
);

Vue.config.productionTip = false;

Vue.filter("formatPrice", function (value, lang = null) {
  if (!lang) lang = localStorage.getItem("locale") || "en";

  return new Intl.NumberFormat(lang, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
});

Vue.filter("numberFormat", function (value, lang = null) {
  if (!lang) lang = localStorage.getItem("locale") || "en";

  if (value === null || value === undefined || value === "") return "";
  return new Intl.NumberFormat(lang).format(value);
});

Vue.filter("capitalize", function (value) {
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
});

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
